module.exports = __webpack_public_path__ + "static/media/javascript-fullstack.0177d53e.jpg";